import React from 'react'

import {SvgIcon, SvgIconProps} from './SvgIcon'

const TimeBadgeIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <path
      d="M17.9599 17.0007C22.3585 14.0271 24.1755 9.03015 22.0186 5.83955C19.8617 2.64899 14.5475 2.47303 10.149 5.44655C5.75055 8.42008 3.93335 13.4171 6.09028 16.6077C8.24721 19.7983 13.5615 19.9741 17.9599 17.0007Z"
      fill="#E0DEDA"
    />
    <path d="M10.9183 9.61569L12.305 10.1557L16.265 4.52234L15.8117 4.25568" />
    <path d="M18.9517 12.3757L19.2717 11.849L18.5184 11.629L18.2917 11.989" />
    <path d="M5.77837 6.26239L5.45837 6.78239L6.21171 7.00906L6.44504 6.64906" />
    <path d="M6.29834 16.429L6.83167 16.729L7.17834 16.0757L6.83834 15.8624" />
    <path d="M17.7783 2.35567L17.2383 2.08234L16.9183 2.74234L17.265 2.949" />
    <path d="M11.7184 8.76904L10.925 9.63571L16.2984 11.6357L16.3317 10.7757" />
    <path
      d="M16.1236 15.2714C20.5222 12.2979 22.3392 7.30088 20.1823 4.11033C18.0254 0.919742 12.7112 0.743776 8.31271 3.7173C3.91422 6.69082 2.09704 11.6878 4.25399 14.8784C6.41091 18.069 11.7252 18.245 16.1236 15.2714Z"
      fillOpacity={0}
      stroke="#21201F"
    />
    <path d="M18.865 17.1956C17.8162 18.5276 16.446 19.571 14.8831 20.2278C13.3202 20.8847 11.616 21.1335 9.93064 20.9508C8.24524 20.7681 6.63398 20.1598 5.24819 19.1832C3.86242 18.2066 2.7476 16.8938 2.0086 15.3681C1.26961 13.8423 0.930682 12.1538 1.02358 10.461C1.11648 8.76825 1.63817 7.12692 2.5397 5.69118C3.44122 4.25546 4.69291 3.07256 6.17724 2.25351C7.66158 1.43447 9.32978 1.00624 11.025 1.00904C11.365 1.00904 11.6917 1.00902 12.0384 1.06235C12.651 0.907289 13.2754 0.802515 13.9051 0.749035C12.9686 0.480615 11.9992 0.343755 11.025 0.342375C9.11958 0.337915 7.24771 0.843942 5.60406 1.80788C3.9604 2.7718 2.60492 4.15843 1.67861 5.82358C0.752295 7.48872 0.288949 9.37158 0.336729 11.2764C0.384509 13.1813 0.941709 15.0386 1.95034 16.6552C2.95897 18.2718 4.38224 19.5888 6.07218 20.4691C7.76211 21.3494 9.65698 21.761 11.5598 21.661C13.4626 21.561 15.304 20.953 16.8923 19.9005C18.4806 18.8479 19.758 17.3891 20.5917 15.6757C20.0604 16.2306 19.4828 16.739 18.865 17.1956Z" />
  </SvgIcon>
)

export default TimeBadgeIcon
